import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { setFetch } from "../../store/slices/puestosSlice.ts";
import { RootState } from "../../store";
import { notification } from "../../utils/Notifications.tsx";
import { softDeleteVacancie } from "../../services/vacancy.service.ts";

const SoftDeleteRecordPuestos = ({ closeFn }: { closeFn: () => void }) => {
  const { currentRecord, fetch } = useSelector(
    (state: RootState) => state.puestos
  );
  const dispatch = useDispatch();

  const removeRecord = async () => {
    try {
      const response = await softDeleteVacancie(currentRecord.id);
      console.log(response);
      dispatch(setFetch(!fetch));
      closeFn();
      notification("Eliminado", "Puesto eliminado", "success");
    } catch (error) {
      console.log(error);
      notification("Error", error.message, "danger");
    }
  };

  return (
    <React.Fragment>
      <p className="fs-15px">
        ¿Estás seguro de que deseas eliminar a {currentRecord.name}?
      </p>
      <div className="d-flex justify-content-end">
        <button className="btn btn-secondary me-2" onClick={() => closeFn()}>
          Cancelar
        </button>
        <button className="btn btn-danger" onClick={() => removeRecord()}>
          Eliminar
        </button>
      </div>
    </React.Fragment>
  );
};

export default SoftDeleteRecordPuestos;
